import { render, staticRenderFns } from "./FrzSelectionResumeKG.vue?vue&type=template&id=353c68d5"
import script from "./FrzSelectionResumeKG.vue?vue&type=script&lang=js"
export * from "./FrzSelectionResumeKG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports